import React from 'react'
import {
  Checkbox,
  FormFieldGroup,
  TextInput,
  Button,
  CloseButton,
  IconButton,
  Flex,
  IconCopyLine,
  IconDuplicateLine,
  Modal,
  Heading
} from '@instructure/ui'
import EditRegistration from './EditRegistration'
import EditLtiRegistration from './EditLtiRegistration'
import { proxyRegistration } from "./registrations";
import ToggleLock from "./ToggleLock";


// We might want to put this into a modal.
const EditTool = ({ open, onClose, onSave, onChange, value }) => {
  const [hideSecret, setHideSecret] = React.useState(true)

  const copyToClipboard = async () => {
    const json = JSON.stringify(value, null, 4)

    if (!navigator || !navigator.clipboard || typeof navigator.clipboard.writeText !== 'function') {
      console.error('Clipboard copy is not supported in this browser.')
      window.alert('Clipboard copy is not supported in this browser. Please copy the text manually.')
      return
    }

    try {
      await navigator.clipboard.writeText(json)
    } catch (error) {
      console.error('Failed to copy to clipboard.', error)
      window.alert('Failed to copy to clipboard. Please copy the text manually.')
    }
  }

  const pasteFromClipboard = async () => {
    if (!navigator || !navigator.clipboard || typeof navigator.clipboard.readText !== 'function') {
      console.error('Clipboard paste is not supported in this browser.')
      window.alert('Clipboard paste is not supported in this browser.')
      return
    }

    try {
      const text = await navigator.clipboard.readText()
      const json = JSON.parse(text)
      // Copy/paste shouldn't include a change in the ID, just the other details 
      delete json.id
      // TODO Need to check we have good state.
      onChange(json)
    } catch (error) {
      console.error('Failed to paste from clipboard or parse clipboard contents.', error)
      window.alert('Failed to paste from clipboard. Make sure the clipboard contains valid JSON.')
    }
  }

  const title = (value.id ? 'Edit' : 'Add') + ' Tool'
  return <Modal open={open} size='fullscreen' label={title}>
    <Modal.Header>
      <CloseButton
        placement='end'
        offset='small'
        onClick={onClose}
        screenReaderLabel='Close'
      />
      <Heading>{title}</Heading>

    </Modal.Header>
    <Modal.Body>
      <Flex direction='column'>
        <Flex.Item padding='xx-small'>
          <EditLtiRegistration name='LTI Registration' value={value.lti}
                               onChange={lti => onChange({ lti: { ...lti } })}/>
        </Flex.Item>
        <Flex.Item padding='xx-small'>
          <FormFieldGroup name='Proxy' description='Proxy' layout='inline' vAlign='top'>
            <Checkbox
              label='Enable'
              checked={value.proxy !== null}
              variant='toggle'
              value='true'
              onChange={(e) => {
                onChange({ proxy: (e.target.checked === true ? { ...proxyRegistration } : null) })
              }}
            />
          </FormFieldGroup>
        </Flex.Item>
        <Flex.Item padding='xx-small'>
          <EditRegistration
            name='Proxy Registration'
            value={value.proxy}
            disabled={value.proxy === null}
            onChange={proxy => onChange({ proxy: { ...proxy } })}/>
        </Flex.Item>
        <Flex.Item padding='x-small'>
          <FormFieldGroup description='Server Side Requests' layout='inline' vAlign='top'>
            <TextInput renderLabel='Issuer' value={value.issuer}
              // autoComplete='off'
                       onChange={(_, issuer) => onChange({ issuer })}/>
            <TextInput renderLabel='Secret' value={value.secret}
                       type={hideSecret ? 'password' : 'text'}
                       autoComplete='off'
                       renderAfterInput={<ToggleLock onChange={setHideSecret}/>}
                       onChange={(_, secret) => onChange({ secret })}/>
          </FormFieldGroup>
        </Flex.Item>
      </Flex>
    </Modal.Body>
    <Modal.Footer>
      <Flex width='100%'>
        <Flex.Item>
          <IconButton margin='x-small' screenReaderLabel='Copy' size='small'
                      withBackground={false} withBorder={false}
                      onClick={copyToClipboard}><IconCopyLine/></IconButton>
        </Flex.Item>
        <Flex.Item>
          <IconButton margin='x-small' screenReaderLabel='Paste' size='small'
                      withBackground={false} withBorder={false}
                      onClick={pasteFromClipboard}><IconDuplicateLine/></IconButton>
        </Flex.Item>
        <Flex.Item shouldGrow></Flex.Item>
        <Flex.Item>
          <Button margin='none small' onClick={onClose}>Cancel</Button>
          <Button margin='none small' onClick={onSave}
                  color='primary'>{value.id ? 'Update' : 'Add'}</Button>
        </Flex.Item>
      </Flex>
    </Modal.Footer>
  </Modal>
}

export default EditTool
